export default {
  SET_INITIAL_POSITION_FOR_XP(state, value) {
    state.xpInitialPosition = value;
  },
  SET_FINAL_POSITION_FOR_XP(state, value) {
    state.xpFinalPosition = value;
  },
  SET_INITIAL_POSITION_FOR_GOLD(state, value) {
    state.goldInitialPosition = value;
  },
  SET_FINAL_POSITION_FOR_GOLD(state, value) {
    state.goldFinalPosition = value;
  },
  SET_ANIMATION_STATUS(state, value) {
    state.isAnimationTrue = value;
  },
  SET_GOLD_ID(state, value) {
    state.goldId = value;
  },
};
